import { Link, useRouter } from './../util/router';
import { MagnifyingGlassIcon, FunnelIcon } from '@heroicons/react/24/outline';
import { useMedia } from 'react-use';
import { useTextSearchStore } from '../stores';
import React from 'react';
import NavbarProfileMenu from './NavbarProfileMenu';
import wordmark from '../assets/images/wordmark.png';

const Navbar = ({ isEmbed }) => {
  const { location } = useRouter();
  const isWide = useMedia('(min-width: 480px)');
  const { isInputOpen, setIsInputOpen } = useTextSearchStore();

  if (location.pathname === '/feed' && !isEmbed) return null;

  return (
    <header className="sticky top-0 z-50 w-full bg-slate-100">
      <nav className="mx-auto flex items-center justify-between p-6 lg:px-8" aria-label="Global">
        <div className="flex lg:flex-1">
          {isEmbed ? (
            <a href="https://showrunner.co" target="_blank" rel="noopener noreferrer">
              <img src={wordmark} alt="_" className="w-48" />
            </a>
          ) : (
            <Link
              to="/feed"
              className="Showrunner text-secondary-red text-2xl font-medium uppercase leading-none"
            >
              <img src={wordmark} alt="_" className="w-48" />
            </Link>
          )}
        </div>
        <div className="flex items-center">
          {location.pathname === '/' &&
            !isWide &&
            (isInputOpen ? (
              <FunnelIcon
                className="stroke-2 text-secondary-red h-5 w-5 mr-2 my-auto"
                aria-hidden="true"
                onClick={() => setIsInputOpen(false)}
              />
            ) : (
              <MagnifyingGlassIcon
                className="stroke-2 text-secondary-red h-5 w-5 mr-2 my-auto"
                aria-hidden="true"
                onClick={() => setIsInputOpen(true)}
              />
            ))}
          {!isEmbed && <NavbarProfileMenu />}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
